import { h } from './chunk-DCAKKOYV.js';

async function r(t,o){let[{DotLottieStateMachineManager:a}]=await Promise.all([import('./dotlottie-state-machine-manager-2E7RUGJG.js')]);if(!t.length)throw h("No state machines available inside this .lottie!");return new a(t,o)}

export { r as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-GSRQSB3U.js.map